import styled from 'styled-components';

export const CellColContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
